import { z } from 'zod'

import { BusinessEmailSchema, DomainSchema } from 'shared/api/common/schemas/email'

const businessEmailInfoResponseSchema = z.object({
  page_name: z.string(),
  email: z.string(),
})

export const emailsSchemas = {
  getBusinessEmailInfo: {
    request: z.undefined(),
    response: businessEmailInfoResponseSchema,
    query: z.object({ email_verification_code: z.string() }),
    path: z.undefined(),
  },
  sendVerifyAccountBusinessEmail: {
    request: z.object({ email: z.string() }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  confirmBusinessEmail: {
    request: z.object({ email_verification_code: z.string() }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  removeBusinessEmail: {
    request: z.object({ email: z.string() }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  verifyBusinessDomain: {
    request: z.object({ domain_id: z.number() }),
    response: z.object({ domain: DomainSchema }),
    query: z.undefined(),
    path: z.undefined(),
  },
  updateBusinessEmail: {
    request: z.object({
      email_id: z.number().nullable(),
      sender_name: z.string().nullable(),
      reply_to: z.string().nullable(),
      is_default: z.boolean(),
    }),
    response: z.object({ email: BusinessEmailSchema }),
    query: z.undefined(),
    path: z.undefined(),
  },
  addBusinessEmail: {
    request: z.object({
      email: z.string(),
      sender_name: z.string().nullable(),
      reply_to: z.string().nullable(),
      is_default: z.boolean(),
    }),
    response: z.object({ email: BusinessEmailSchema }),
    query: z.undefined(),
    path: z.undefined(),
  },
  getBusinessEmails: {
    request: z.object({
      email_id: z.number().nullable(),
      sender_name: z.string().nullable(),
      reply_to: z.string(),
      is_default: z.boolean(),
    }),
    response: z.object({ emails: z.array(BusinessEmailSchema) }),
    query: z.undefined(),
    path: z.undefined(),
  },
}
